import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@shared/services';

@Component({
  selector: '',
  template: '',
  styleUrls: []
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private session: SessionService
  ) { }

  async ngOnInit() {
    await this.session.logout();
    this.router.navigate(['/login']);
  }

}
